























































































import {
  Component, Mixins, Watch,
} from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import ReportModule from '@/store/modules/Report';
import AuthModule from '@/store/modules/Auth';
import GameModule from '@/store/modules/Game';
import Table from '@/components/Table/Index.vue';
import Breadcrumb from '@/components/Breadcrumb.vue';
import InvoiceBody from '@/components/Table/InvoiceBody.vue';
import LogBody from '@/components/Table/LogBody.vue';
import Pagination from '@/components/Pagination.vue';
import ToolMixin from '@/mixins/Tool.vue';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';
import PaginationMixin from '@/mixins/Pagination.vue';
import InvoiceData from '@/data/InvoiceData';

@Component({
  components: {
    Table,
    Breadcrumb,
    Pagination,
    InvoiceBody,
    LogBody,
  },
})
export default class Invoice extends Mixins(
  ToolMixin, ErrorHandleMixin, PaginationMixin,
) {
  ReportInstance = getModule(ReportModule, this.$store);

  AuthInstance = getModule(AuthModule, this.$store);

  GameInstance = getModule(GameModule, this.$store);

  componentKey = 0;

  agent = [
    {
      user: {
        username: '',
      },
    },
  ];

  Criteria = {
    ...this.Period,
    isSearch: false,
    multiCurrency: false,
    gameName: ['total'],
    products: ['total'],
    role: this.AuthInstance.user.role,
    userId: this.AuthInstance.user._id,
    username: this.AuthInstance.user.username,
    source: this.AuthInstance.user.source,
    limit: 100,
    page: 1,
  };

  DefaultGameList = [
    {
      name: {
        en: 'Total',
        th: 'ทั้งหมด',
      },
      prefix: 'total',
    },
  ]

  GameList: any = [];

  BreadcrumbList: any = [];

  PaginationDetail = {
    current: 1,
    amount: 0,
    size: 100,
  }

  BreadcrumbDefault = [
    {
      username: this.AuthInstance.user.username,
      source: this.AuthInstance.user.source,
      role: this.AuthInstance.user.role,
      userId: this.AuthInstance.user._id,
    },
  ];

  type = '';

  WinLoseList: any = {};

  resultData: any = {};

  dataList: any = [];

  LoginName = '';

  TableHeadMember = [...InvoiceData.TableHeadMember];

  FilteredTableHeadMember: any = [...InvoiceData.TableHeadMember];

  TableHeadLog: any = [];

  mode = 'agent';

  dataKey = 'users';

  isMember = false;

  detailFooterCol = 0;

  totalLog = 0;

  summaryLog = 0;

  houseEdge = 0;

  startdate = '';

  enddate = '';

  aaa = [];

  selected = {
    user: {
      id: '',
      username: '',
    },
    _id: '',
  };

  firstFetch = true;

  filterId = {}

  firstId = ''

  startCount = 0;

  momentFormat = {
    stringify: (date) => this.$moment(date).format('DD-MM-YYYY'),
    parse: (value) => this.$moment(value).format('DD-MM-YYYY'),
  }

  @Watch('Period.start.date', { immediate: true, deep: true })
  watchPeriodStart() {
    const datestart = this.$moment(this.Period.start.date).startOf('day').toDate();
    this.startdate = datestart;
  }

  @Watch('Period.end.date', { immediate: true, deep: true })
  watchPeriodEnd() {
    const dateend = this.$moment(this.Period.end.date).endOf('day').toDate();
    this.enddate = dateend;
  }

  created() {
    this.fetchWinLose();
  }

  initial() {
    this.currentTool = 'Today';
    this.Criteria = {
      ...this.Period,
      isSearch: false,
      multiCurrency: false,
      gameName: ['total'],
      products: ['total'],
      role: this.AuthInstance.user.role,
      userId: this.AuthInstance.user._id,
      username: this.AuthInstance.user.username,
      source: this.AuthInstance.user.source,
      limit: 100,
      page: 1,
    };
    this.LoginName = '';
    this.isMember = false;
  }

  changePage(i) {
    this.PaginationDetail.current = i;
    this.Criteria.page = i;
    this.fetchWinLose();
  }

  async fetchWinLose() {
    this.Criteria.isSearch = !!this.LoginName;
    const criteria: any = { ...this.Criteria, ...this.Period };
    criteria.products = criteria.gameName;
    criteria.currentPage = this.PaginationDetail.current;
    criteria.sizePage = this.PaginationDetail.size;
    this.GeneralInstance.toggleLoading(true);
    const { data, status } = await this.ReportInstance.FetchInvoice(criteria);
    this.GeneralInstance.toggleLoading(false);
    this.checkError(status);
    this.resultData = data;
    this.PaginationDetail.amount = data.pageAmount;
    this.startCount = data.startCount;
    this.FilteredTableHeadMember[0] = [...InvoiceData.TableHeadMember[0]]
      .filter((item: any) => !item.isCompanyHidden);
    this.BreadcrumbList = [
      ...this.BreadcrumbDefault,
    ];
  }

  handleSubmit() {
    this.Period.start.date = this.startdate;
    this.Period.end.date = this.enddate;
    this.onSubmit();
  }

  async onSubmit() {
    this.PaginationDetail.current = 1;
    this.Criteria.page = 1;
    this.fetchWinLose();
  }

  handleSearch() {
    this.isMember = this.AuthInstance.user.role === 'ADMIN';
    this.Criteria.username = this.LoginName
      ? this.LoginName
      : this.AuthInstance.user.username;
  }

  handleFetchWinloseAgent(username, role, source) {
    this.beforeFetch(username, role, source);
  }

  handleBreadcrumb({ username, role, source }) {
    this.beforeFetch(username, role, source);
  }

  beforeFetch(username, role, source) {
    this.isMember = role === 'MEMBER';
    this.LoginName = '';
    this.Criteria.username = username;
    this.Criteria.source = source;
    this.Criteria.role = role;
    this.PaginationDetail.current = 1;
    this.fetchWinLose();
  }
}
